module.exports = __webpack_public_path__ + "static/media/location-icon-atlas.7ccdae86.png";